import { render } from "./SearchResultProductScore.vue?vue&type=template&id=0a803014&scoped=true"
import script from "./SearchResultProductScore.vue?vue&type=script&lang=js"
export * from "./SearchResultProductScore.vue?vue&type=script&lang=js"

import "./SearchResultProductScore.vue?vue&type=style&index=0&id=0a803014&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a803014"]])

export default __exports__